export class PaymentCost {
  id: number;
  applicationId: string;
  totalCost: number;
  outstandingBalance: number;
}
